module.exports = new __parcel__URL__("arrow-up-green.cba36635.png").toString();